<template>
<div>
  <div class="d-print-none page-head">
      <div>
         <h3>Invoices</h3>
      </div>
      <div class="sub-nav">
        <router-link to="/invoices/new-invoice" class="mr-3">
          POS
        </router-link>
        <router-link to="/invoices/companies" class="mr-3">
          Registered Clients
        </router-link>
<!--        <router-link to="/invoices/pending-invoices" class="mr-3">-->
<!--          Pending Invoices-->
<!--        </router-link>-->
        <router-link to="/invoices/reports">
          Invoice Reports
        </router-link>
      </div>
  </div>
  <router-view></router-view>
</div>

</template>

<script>
export default {
};
</script>

<style>
</style>
